import { render } from "./Edit.vue?vue&type=template&id=364cffca&bindings={\"errors\":\"props\",\"course\":\"props\",\"content\":\"props\",\"flash\":\"props\",\"form\":\"data\",\"update\":\"options\",\"handleFileUploadSubmit\":\"options\",\"formatBytes\":\"options\"}"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "364cffca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('364cffca')) {
    api.reload('364cffca', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=364cffca&bindings={\"errors\":\"props\",\"course\":\"props\",\"content\":\"props\",\"flash\":\"props\",\"form\":\"data\",\"update\":\"options\",\"handleFileUploadSubmit\":\"options\",\"formatBytes\":\"options\"}", () => {
    api.rerender('364cffca', render)
  })

}

script.__file = "resources/js/Pages/Courses/Edit.vue"

export default script